import App from './app';

export { App };
export default App;
